import { useQuery } from "react-query";
import {
  MRT_ColumnFiltersState,
  MRT_PaginationState,
  MRT_SortingState,
} from "mantine-react-table";
import getInventoryHistoryData, {
  InventoryHistoryResponse,
} from "../services/getInventoryHistoryData";
function useGetInventoryHistoryData(
  token: string,
  pagination: MRT_PaginationState,
  columnFilters: MRT_ColumnFiltersState,
  sorting: MRT_SortingState
) {
  return useQuery<InventoryHistoryResponse>({
    queryKey: [
      "get-inventory-history-data",
      pagination,
      columnFilters,
      sorting,
    ],
    queryFn: () =>
      getInventoryHistoryData({ token, pagination, columnFilters, sorting }),
    retry: false,
    keepPreviousData: true,
    staleTime: 30_000,
  });
}

export default useGetInventoryHistoryData;
